import { LogoUpload } from '@/components/LogoUpload/LogoUpload';
import styled from '@emotion/styled';
import { useController, useFormContext } from 'react-hook-form';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;

export const LogoField = () => {
    const { control } = useFormContext();
    const { field } = useController({
        name: 'logo_src',
        control,
    });

    return (
        <Container>
            <Title id="campaign-logo-field">Logo</Title>
            <LogoUpload file={field.value} onChange={field.onChange} onBlur={field.onBlur} ref={field.ref} />
        </Container>
    );
};
